import React from 'react'
import { Field } from 'redux-form'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import { required } from 'app/utils/validations'

const IssueCategorySelect = ({ formValues }) =>
  <>
    <Field component={LgySelectField} label='Issue category' name='issueType' validate={required} required>
      <option value='Registration'>Registration</option>
      <option value='LGY Hub Login problem'>LGY Hub Login problem</option>
      <option value='Admin Needs Activation'>Admin Needs Activation</option>
      <option value='LGY  Pin issue'>LGY  Pin issue</option>
      <option value='LGY User inactive/deactivated'>LGY User inactive or deactivated</option>
      <option value='Access Request (VA Employee)'>Access Request (VA Employee)</option>
      <option value='Upload problem'>Upload problem</option>
      <option value='Print problem'>Print problem</option>
      <option value='Page Not Working'>Page Not Working</option>
      <option value='FFPS'>FFPS</option>
      <option value='Outage'>Outage</option>
      <option value='PMDI Request'>PMDI Request</option>
      <option value='Change of Employment'>Change of Employment</option>
      <option value='Follow Up (Provide ticket number)'>Follow Up (Provide ticket number)</option>
      <option value='Feature Request'>Feature Request</option>
      <option value='Feedback Item'>Feedback Item</option>
      <option value='Other'>Other</option>
    </Field>

    {formValues.issueType && formValues.issueType === 'Registration' && <Field component={LgySelectField} label='Issue Subcategory' name='issueSubType' validate={required} required>
        <option value='LGY Hub Registration – ID.me'>LGY Hub Registration – ID.me</option>
        <option value='LGY Hub Registration – New User'>LGY Hub Registration – New User</option>
        <option value='FFPS Registration'>FFPS Registration</option>
      </Field>}

    {formValues.issueType && formValues.issueType === 'FFPS' && <Field component={LgySelectField} label='Issue Subcategory' name='issueSubType' validate={required} required>
        <option value='FFPS password'>FFPS password</option>
        <option value='FFPS Pin'>FFPS Pin</option>
        <option value='FFPS Admin'>FFPS Admin</option>
        <option value='FFPS Payment Issue'>FFPS Payment Issue</option>
        <option value='FFPS Refund'>FFPS Refund</option>
        <option value='FFPS Organization set up'>FFPS Organization set up</option>
      </Field>}

    {formValues.issueType && formValues.issueType === 'Outage' && <Field component={LgySelectField} label='Issue Subcategory' name='issueSubType' validate={required} required>
        <option value='WebLGY Outage'>WebLGY Outage</option>
        <option value='LGY Hub Outage'>LGY Hub Outage</option>
        <option value='FFPS Outage'>FFPS Outage</option>
        <option value='Other Outage'>Other Outage</option>
      </Field>}
  </>
export default IssueCategorySelect